<template>
  <div class="header-component">
    <Logo />
    <div class="cursor-pointer" @click="navigateTo('Login')">Pension Keeper Login</div>
  </div>
</template>
<script>
// Components
import Logo from '@/components/common/Logo/Logo.vue';
export default {
  name: 'HeaderComponent',
  components: {
    Logo
  },
  methods: {
    navigateTo(pageName) {
      if (!pageName) {
        return;
      }
      this.$router.push({ name: pageName });
    }
  }
};
</script>
